module.exports = __webpack_public_path__ + "static/media/sign_in_bg.6160f4da.jpg";